const Index = () => import(/* webpackChunkName: "todayOrders" */ '@/components/orders/todayOrders')
export default {
    name: 'todayOrders',
    path: 'todayOrders',
    redirect: '/todayOrders/index',
    meta: {label: 'todayOrders'},
    component: {
        render (c) { return c('router-view') }
    },
    children: [
        {
            path: 'index',
            meta: {label: 'Index', auth: true},
            component: Index,
            props: true
        }
    ]
}
